import dynamic from 'next/dynamic'
import { Suspense } from 'react'

import getIsProduction from '@/helpers/utils/getIsProduction'
const Stub = Promise.resolve(() => null)
const Debug_ = dynamic(() => (!getIsProduction() && process.env.NODE_ENV !== 'test' ? import('./Debug') : Stub), {
  ssr: false,
})
export default function Debug() {
  return (
    <Suspense fallback={null}>
      <Debug_ />
    </Suspense>
  )
}
